module.exports = __webpack_public_path__ + "img/more.b497a013.svg";